<script>
import { Component, Vue, Prop } from "vue-property-decorator";
import { setInfo2, copySetInfo2 } from "./config";
import { setArray } from "../../excipient/artificial/config";
import printFooter from "./print-footer.vue";
import printHead from "./print-head.vue";
import API from "src/common/api";
@Component({
  name: "normal-print",
  components: { printHead, printFooter },
})
export default class App extends Vue {
  info = {
    table1: {},
    table2: {},
    table3: {},
    table4: {},
  };
  defailInfo = {};
  list = [];
  isM60_2004 = false
  POST_INVOICE_SCMPREINVOICEHEADER_GETPRINTDATA() {
    return new Promise((resolve, reject) => {
      this.$apis.autoAPi
        .POST_INVOICE_SCMPREINVOICEHEADER_GETPRINTDATA({
          id: this.$route.query.id,
        })
        .done((res) => {
          resolve(res);
        })
        .fail((err) => {
          reject();
        });
    });
  }
  get zoomStyle() {
    return {
      fontSize: "10px",
      transform: "scale(0.8)",
      width: "125%",
    };
  }
  mounted() {
    const __this = this;
    this.POST_INVOICE_SCMPREINVOICEHEADER_GETPRINTDATA()
      .then((res) => { 
        this.defailInfo = res.data;
        if(this.defailInfo.brandCode == '6' && this.defailInfo.companyCode == '2004') {
          __this.isM60_2004 = true
        }
        const spliceArray = [];
        const total = {
          includingTaxPriceTotal: 0,
          noTaxPriceTotal: 0,
          taxPriceTotal: 0,
        };
        res.data.itemList.forEach((item, $index) => {
          total.includingTaxPriceTotal += Number(item.includingTaxPrice || 0);
          total.noTaxPriceTotal += Number(item.noTaxPrice || 0);
          total.taxPriceTotal += Number(item.taxPrice || 0);
          const i = parseInt($index / 12);
          if (!spliceArray[i]) spliceArray[i] = [];
          spliceArray[i].push(item);
        });
        this.list = spliceArray.map((item, index) => {
          const setInfo2Info = setInfo2.call(this, res.data, this.isM60_2004);
          setInfo2Info.children = setArray(
            setInfo2Info.children.concat(item.map(setItemList)),
            13,
            copySetInfo2(this.isM60_2004)
          );
          if(index === spliceArray.length -1) {
            setInfo2Info.children.push(setTotalItem(total));
          }
          return {
            table2: setInfo2Info,
          };
        });

        let productManagerName = getAuditName(this.defailInfo.flowConfigList, '业务审核人')
        let productManagerDate = getAuditDate(this.defailInfo.flowLogList, '业务审核人')
        this.defailInfo.productManager = productManagerDate ?  `${productManagerName}  ${this.$utils.formatTime(productManagerDate)}` : ''

        let productManagerName2 = getAuditName(this.defailInfo.flowConfigList, '生管经理审核人')
        let productManagerDate2 = getAuditDate(this.defailInfo.flowLogList, '生管经理审核人')
        this.defailInfo.productDirector = productManagerDate2 ? `${productManagerName2}  ${this.$utils.formatTime(productManagerDate2)}` : ''

        let costManagerName = getAuditName(this.defailInfo.flowConfigList, '成控审核人')
        let costManagerDate = getAuditDate(this.defailInfo.flowLogList, '成控审核人')
        this.defailInfo.costManager = costManagerDate ? `${costManagerName}  ${this.$utils.formatTime(costManagerDate)}` : ''

        let statisticalExaminerName = getAuditName(this.defailInfo.flowConfigList, '统计审核人')
        let statisticalExaminerDate = getAuditDate(this.defailInfo.flowLogList, '统计审核人')
        this.defailInfo.statisticalExaminer = statisticalExaminerDate ? `${statisticalExaminerName}  ${this.$utils.formatTime(statisticalExaminerDate)}` : ''

        let costManagerRegistExaminerName = getAuditName(this.defailInfo.flowConfigList, '成控签批')
        let costManagerRegistExaminerDate = getAuditDate(this.defailInfo.flowLogList, '成控签批')
        this.defailInfo.costManagerRegistExaminer = costManagerRegistExaminerDate ? `${costManagerRegistExaminerName}  ${this.$utils.formatTime(costManagerRegistExaminerDate)}` : ''

        this.defailInfo.created = `${this.defailInfo.createdByName} ${this.$utils.formatTime(this.defailInfo.createdTime)}`

      })
      .catch((err) => {});

    function setItemList(item) {
      return {
        style: {
          height: "10mm",
          flex: "none",
        },
        children: [
          {
            style: {
              width: "25mm",
              flex: "none",
            },
            textStyle: __this.zoomStyle,
            width: null,
            text: item.materialCode,
          },
          {
            style: {
              width: "12mm",
              flex: "none",
            },
            textStyle: __this.zoomStyle,
            width: null,
            text: item.warehousNumber,
          },
          {
            style: {
              width: "12mm",
              flex: "none",
            },
            textStyle: __this.zoomStyle,
            width: null,
            text: item.price,
          },
          {
            style: {
              width: "8mm",
              flex: "none",
            },
            textStyle: __this.zoomStyle,
            width: null,
            text: item.taxNumber,
          },
          {
            style: {
              width: "15mm",
              flex: "none",
              textAlign:"right"
            },
            textStyle: __this.zoomStyle,
            width: null,
            text: (item.contractPrice || 0).toFixed(2),
          },
          {
            style: {
              width: "15mm",
              flex: "none",
              textAlign:"right"
            },
            textStyle: __this.zoomStyle,
            width: null,
            text: (item.sapPrice || 0).toFixed(2),
          },
          {
            style: {
              width: "18mm",
              flex: "none",
              textAlign:"right"
            },
            textStyle: __this.zoomStyle,
            width: null,
            text: (item.differencePrice || 0).toFixed(2),
          },
          {
            style: {
              width: "15mm",
              flex: "none",
              textAlign:"right"
            },
            textStyle: __this.zoomStyle,
            width: null,
            text: (item.includingTaxPrice || 0).toFixed(2),
            hide: __this.isM60_2004
          },
          {
            style: {
              width: "20mm",
              flex: "none",
              textAlign:"right"
            },
            textStyle: __this.zoomStyle,
            width: null,
            text: (item.noTaxPrice || 0).toFixed(2),
          },
          {
            style: {
              width: "20mm",
              flex: "none",
              textAlign:"right"
            },
            textStyle: __this.zoomStyle,
            width: null,
            text: (item.taxPrice || 0).toFixed(2),
            hide: __this.isM60_2004
          },
          {
            style: {
              width: "18mm",
              flex: "none",
            },
            textStyle: __this.zoomStyle,
            width: null,
            text: item.sapOrderNo,
          },
          {
            style: {
              width: "15mm",
              flex: "none",
            },
            textStyle: __this.zoomStyle,
            width: null,
            text: "",
          },
          {
            style: {
              width: "15mm",
              flex: "none",
            },
            textStyle: __this.zoomStyle,
            width: null,
            text: "",
          },
          {
            style: {
              fontSize: "12px",
            },
            textStyle: __this.zoomStyle,
            width: null,
            text: item.remark,
          },
        ],
      };
    }

    function setTotalItem(totalItem) {
      return {
        style: {
          height: "12mm",
          flex: "none",
        },
        children: [
          {
            style: {
              width: "25mm",
              fontWeight: "500",
              flex: "none",
            },
            textStyle: __this.zoomStyle,
            width: null,
            text: "合计：",
          },
          {
            style: {
              width: "12mm",
              flex: "none",
            },
            width: null,
            text: "",
          },
          {
            style: {
              width: "12mm",
              flex: "none",
            },
            width: null,
            text: "",
          },
          {
            style: {
              width: "8mm",
              flex: "none",
            },
            width: null,
            text: "",
          },
          {
            style: {
              width: "15mm",
              flex: "none",
            },
            width: null,
            text: "",
          },
          {
            style: {
              width: "15mm",
              flex: "none",
            },
            width: null,
            text: "",
          },
          {
            style: {
              width: "18mm",
              flex: "none",
            },
            width: null,
            text: "",
          },
          {
            style: {
              width: "15mm",
              flex: "none",
              textAlign:"right"
            },
            textStyle: __this.zoomStyle,
            width: null,
            text: (totalItem.includingTaxPriceTotal || 0).toFixed(2),
            hide: __this.isM60_2004
          },
          {
            style: {
              width: "20mm",
              flex: "none",
              textAlign:"right"
            },
            textStyle: __this.zoomStyle,
            width: null,
            text: (totalItem.noTaxPriceTotal || 0).toFixed(2),
          },
          {
            style: {
              width: "20mm",
              flex: "none",
              textAlign:"right"
            },
            textStyle: __this.zoomStyle,
            width: null,
            text: (totalItem.taxPriceTotal || 0).toFixed(2),
            hide: __this.isM60_2004
          },
          {
            style: {
              width: "18mm",
              flex: "none",
            },
            width: null,
            text: "",
          },
          {
            style: {
              width: "15mm",
              flex: "none",
            },
            width: null,
            text: "",
          },
          {
            style: {
              width: "15mm",
              flex: "none",
            },
            width: null,
            text: "",
          },
          {
            // style: {
            //   width: "100mm",
            //   flex: "none",
            //   fontSize: "12px",
            // },
            width: null,
            text: "",
          },
        ],
      };
    }

    function getAuditName(list=[], type) {
      let result = list.find(item => item.roleName == type)
      return result ? result.userName : ''
    }
    function getAuditDate(flowLogList=[], type) {
      let list = flowLogList.sort((a, b) => b.createdTime - a.createdTime ).filter(item => item.auditStatus == 0)
      let result = list.find(item => item.auditNode == type)
      return result ? result.createdTime : ''
    }
  }
  render(h) {
    return (
      <div class="excipient-print">
        {this.list.map((item, index) => {
          return (
            <div class="excipient-print__item">
              <print-head
                {...{
                  props: {
                    info: {
                      code: this.defailInfo.factoryCode,
                      name: this.defailInfo.factoryName,
                      company: this.defailInfo.companyName,
                      type: this.defailInfo.typeDesc,
                      invoiceOrderNo: this.defailInfo.invoiceOrderNo,
                    },
                  },
                }}
              />
              <multiline-print
                {...{
                  props: {
                    info: item.table2,
                  },
                }}
              ></multiline-print>
              <print-footer
                {...{
                  props: {
                    productManagerName: this.defailInfo.productManager,
                    costManagerName: this.defailInfo.costManager,
                    createByName: this.defailInfo.created,
                    productDirectorName: this.defailInfo.productDirector,
                    statisticalExaminerName: this.defailInfo.statisticalExaminer,
                    costManagerRegistExaminerName: this.defailInfo.costManagerRegistExaminer,
                      currentPage: index + 1,
                      totalPage: this.list.length
                  },
                }}
              />
            </div>
          );
        })}
      </div>
    );
  }
}
</script>


<style scoped>
@media print {
  .excipient-print__item {
    page-break-inside: avoid !important;
    page-break-before: unset !important;
    padding: 15px;
    padding-bottom: 0;
  }
}
.excipient-print__item {
  margin-bottom: 6mm;
  page-break-inside: avoid !important;
    page-break-before: unset !important;
}
</style>